import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TabsMobile from "../__template/TabsMobileComponent";
import bsi from "../../assets/images/icon_topup/bsi.svg";
import bersama from "../../assets/images/icon_topup/bersama.svg";
import { faAudioDescription } from "@fortawesome/free-solid-svg-icons";
import Carousel from "react-multi-carousel";
import { useLocation, useParams } from "react-router-dom";
import CopyToClipboard from "react-copy-to-clipboard";
import copy from "../../assets/images/icon_topup/copy.svg";
import { toast } from "react-toastify";
import { getTutorialApi } from "../../core/service/api_topup";
import { formatCurrency } from "../../config/global";
import emptyIcon from "../../assets/images/empty-data.svg";
import image1 from "../../assets/images/idn/image1.png";
import image2 from "../../assets/images/idn/image2.png";
import image3 from "../../assets/images/idn/image3.png";
import image4 from "../../assets/images/idn/image4.png";
import image5 from "../../assets/images/idn/image5.png";
import image6 from "../../assets/images/idn/image6.png";
import image7 from "../../assets/images/idn/image7.png";
import image8 from "../../assets/images/idn/image8.png";
import image9 from "../../assets/images/idn/image9.png";
import image10 from "../../assets/images/idn/image10.png";
import image11 from "../../assets/images/idn/image11.png";
import image12 from "../../assets/images/idn/image12.png";
import image13 from "../../assets/images/idn/image13.png";
import image14 from "../../assets/images/idn/image14.png";
import image15 from "../../assets/images/idn/image15.png";
import image16 from "../../assets/images/idn/image16.png";
import image17 from "../../assets/images/idn/image17.png";
import image18 from "../../assets/images/idn/image18.png";
import image19 from "../../assets/images/idn/image19.png";
import image20 from "../../assets/images/idn/image20.png";
import image21 from "../../assets/images/idn/image21.png";
import image22 from "../../assets/images/idn/image22.png";
import image23 from "../../assets/images/idn/image23.png";
import image24 from "../../assets/images/idn/image24.png";
import image25 from "../../assets/images/idn/image25.png";
import image26 from "../../assets/images/idn/image26.png";
import image27 from "../../assets/images/idn/image27.png";
import image28 from "../../assets/images/idn/image28.png";
import image29 from "../../assets/images/idn/image29.png";
import image30 from "../../assets/images/idn/image30.png";
import image31 from "../../assets/images/idn/image31.png";
import image32 from "../../assets/images/idn/image32.png";
import image33 from "../../assets/images/idn/image33.png";
import image34 from "../../assets/images/idn/image34.png";
import image35 from "../../assets/images/idn/image35.png";
import image36 from "../../assets/images/idn/image36.png";

const ComponentTopupTutorial = () => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const [kodeFull, setKodeFull] = useState("");
  const [kodeInstitusi, setKodeInstitusi] = useState("");
  const [kodeBayar, setKodeBayar] = useState("");
  const [tutorial, setTutorial] = useState("");
  const location: any = useLocation();
  const [stateData, setStateData] = useState(location?.state?.data);

  useEffect(() => {
    let inputStr = location?.state?.va;
    console.log(location?.state?.data, "sdhjkl;");
    setKodeFull(inputStr);
    setKodeInstitusi(inputStr.slice(3, 7));
    setKodeBayar(inputStr.slice(7));
    getTutorial();
  }, []);

  const getTutorial = async () => {
    getTutorialApi(stateData?.bankName, stateData?.vaNumber).then((res) => {
      setTutorial(res.data.length ? res.data[0].tutorial : "");
    });
  };
  const onCopy = useCallback(() => {
    setCopied(true);
    toast(t("TOPUP.VACopied"));
  }, []);

  const [dataa, setData] = useState([
    {
      id: "1",
      title: "Pembayaran Melalui BSI Mobile",
      logo: bsi,
      collapse: false,
      description: [
        {
          message: "Pilih menu Pembayaran/Payment",
        },
        {
          message: "Pilih Akademik",
        },
        {
          message: "Masukan kode institusi {{kodeInstitusi}}{{copyInstitusi}}",
        },
        {
          message: "Masukan ID Pelanggan/Kode Bayar {{kodeBayar}}{{copyBayar}}",
        },
        {
          message: "Pilih selanjutnya",
        },
        {
          message: "Masukan nominal yang akan di top up kedalam aplikasi",
        },
        {
          message: "Masukan PIN",
        },
        {
          message: "Konfirmasi transaksi",
        },
        {
          message: "Selesai",
        },
      ],
    },
    {
      id: "2",
      title: "Pembayaran Melalui ATM BSI",
      logo: bsi,
      collapse: false,
      description: [
        {
          message: "Pilih Menu Payment / Pembayaran / Pembelian",
        },
        {
          message: "Pilih Akademik",
        },
        {
          message:
            "Masukan kode institusi {{kodeInstitusi}} + Masukkan Nomor ID Pelanggan {{kodeBayar}}{{copyFull}}",
        },
        {
          message: "Pilih Benar/Selanjutnya",
        },
        {
          message:
            "Kemudian tampil informasi data transaksi anda, pastikan data sudah benar",
        },
        {
          message: "Pilih Benar / Ya",
        },
      ],
    },

    {
      id: "3",
      title: "Pembayaran Melalui ATM Bank Lain",
      logo: bsi,
      collapse: false,
      description: [
        {
          message: "Pilih Transfer",
        },
        {
          message: "Pilih Antar Bank Online / Transfer Online antar Bank",
        },
        {
          message: "Masukan kode BSI 451 atau pilih Bank Mandiri Syariah",
        },
        {
          message:
            "Masukan kode 900 (paten) + kode institusi {{kodeInstitusi}} + ID Pelanggan {{kodeBayar}}{{copyFull}}",
        },
        {
          message: "Masukan nominal tagihan",
        },
        {
          message:
            "Layar akan menampilkan data transaksi anda, jika sudah benar pilih YA (OK)",
        },
        {
          message: "Selesai",
        },
      ],
    },
  ]);

  const responsive2 = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
      slidesToSlide: 3,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1200 },
      items: 1,
      slidesToSlide: 3,
    },
    tablet: {
      breakpoint: { max: 1200, min: 576 },
      items: 1,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };
  const setCollapse = (e: any) => {
    setData((prevData) =>
      prevData.map((item) =>
        item?.id === e ? { ...item, collapse: !item?.collapse } : item
      )
    );
  };
  console.log("");

  return (
    <div className="min-h-screen h-full  px-8 py-8 bg-psp-primary">
      <TabsMobile
        name={`${t("TUTORIAL-TOPUP.title")}`}
        backUrl={"topup"}
      ></TabsMobile>
      <section className="mt-3">
        <div className="mt-4">
          <img src={stateData?.icon} alt="bankIcon" className="w-50" />
        </div>
        <div className="mt-4 flex justify-between">
          <div className="flex flex-col">
            <div className="flex">
              <p className="text-sm font-normal">Nama Bank</p>
            </div>
            <div className="flex">
              <p className="text-sm font-normal">Nama Akun</p>
            </div>
            <div className="flex">
              <p className="text-sm font-normal">Biaya Admin</p>
            </div>
            <div className="flex">
              <p className="text-sm font-normal">Nomor Virtual Account</p>
            </div>
          </div>
          <div className="flex flex-col">
            <div className="flex">
              <p className="text-sm font-normal">{stateData?.name}</p>
            </div>
            <div className="flex">
              <p className="text-sm font-normal">{stateData?.userName}</p>
            </div>
            <div className="flex">
              <p className="text-sm font-normal">
                {formatCurrency(stateData?.adminBank).replace(",00", "")}
              </p>
            </div>
            <div className="flex">
              <p className="text-sm font-normal text-psp-primary mr-2">
                {stateData?.vaNumber}
              </p>
              <CopyToClipboard onCopy={onCopy} text={stateData?.vaNumber}>
                <img src={copy} className="h-3 w-3 mt-1" alt="" />
              </CopyToClipboard>
            </div>
          </div>
        </div>
        <div>
          <span className="text-sm font-bold">Panduan</span>
          {/* {tutorial ? ( */}
          <iframe
            srcDoc={tutorial}
            style={{ width: "100%", height: "100vh", border: "none" }}
            title="HTML Content"
          />
          {/* ) : ( */}
          {/* <div className="flex flex-col items-center mt-4"> */}
          {/* <div> */}
          {/* <img src={emptyIcon} alt="" /> */}
          {/* </div> */}
          {/* <div>{t("TOPUP.notFoundTutorial")}</div> */}
          {/* </div> */}
          {/* )} */}
        </div>
      </section>
    </div>
  );
};

export default ComponentTopupTutorial;
